import { AppLoader } from "components";
import { t } from "i18next";
import { Modal } from "ui";

import { useGetOrderDetails } from "../../../apis";
import { OrderFooter, OrderContent, OrderHeader, OrderInfo } from "./atoms";
import { OrderModalBlock } from "./atoms/blocks";
import { UserBlock } from "./atoms/UserBlock";
import { OrderModalProps } from "./OrderModal.types";

import styles from "./OrderModal.module.scss";

const OrderModal = ({
  orderId,
  isOpen,
  refetchOrders,
  onClose
}: OrderModalProps) => {
  const {
    orderDetails,
    isLoading,
    refetch: refetchOrder
  } = useGetOrderDetails(orderId);

  return (
    <Modal
      title={t("Order Details")}
      className={styles.orderModal}
      isOpen={isOpen}
      onClose={onClose}
      contentClassName={styles.orderModal_content}
      footer={false}
      isLoading={isLoading}
    >
      {isLoading && <AppLoader />}
      {orderDetails && (
        <>
          <OrderHeader
            orderDetails={orderDetails}
            refetchOrder={refetchOrder}
            refetchList={refetchOrders}
          />

          <UserBlock orderDetails={orderDetails} />

          {orderDetails?.cancellationReason && (
            <OrderModalBlock label={t("Reason of cancellation")}>
              <p>{orderDetails?.cancellationReason}</p>
            </OrderModalBlock>
          )}

          <OrderInfo
            orderDetails={orderDetails}
            refetchOrder={refetchOrder}
            refetchOrders={refetchOrders}
          />

          <div className={styles.orderModal__separator} />

          <OrderContent orderDetails={orderDetails} />

          <div className={styles.orderModal__separator} />

          <OrderFooter orderDetails={orderDetails} />
        </>
      )}
    </Modal>
  );
};

export default OrderModal;
